import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PopupData, PopupResult } from '../../../core/models/filter-popup.model';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SimulationSearchFilters } from '../../../core/models/simulation.model';

@Component({
  selector: 'app-filter-options-popup',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule
],
  templateUrl: './filter-options-popup.component.html',
  styleUrl: './filter-options-popup.component.scss',
})
export class FilterOptionsPopupComponent implements OnInit {
  filterForm!: FormGroup;
  dateRangeError = false;
  hideTypes: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FilterOptionsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopupData & { hideTypes?: boolean },
  ) {
    this.hideTypes = data.hideTypes || false;
  }

  ngOnInit(): void {
    this.filterForm = this.createForm();
  }

  private createForm(): FormGroup {
    const savedData = this.data as any;

    const formGroupConfig: any = {
      runStatuses: this.fb.array(
        this.data.statuses.map((availableStatus: string) => {
          const savedStatus = savedData.runStatus?.find(
            (s: any) => s.name === availableStatus || s.id === availableStatus,
          );
          return this.fb.control(savedStatus?.checked || false);
        }),
      ),
      startDate: [savedData.startDate ? new Date(savedData.startDate) : null],
      endDate: [savedData.endDate ? new Date(savedData.endDate) : null],
      directionX: [savedData.directions?.x !== undefined ? savedData.directions.x : true],
      directionY: [savedData.directions?.y !== undefined ? savedData.directions.y : true],
      directionZ: [savedData.directions?.z !== undefined ? savedData.directions.z : true],
    };

    if (!this.hideTypes && this.data.simTypes) {
      formGroupConfig.types = this.fb.array(
        this.data.simTypes.map((availableType: string) => {
          const savedType = savedData.types?.find(
            (t: any) => t.name === availableType || t.id === availableType,
          );
          return this.fb.control(savedType?.checked || false);
        }),
      );
    }

    return this.fb.group(formGroupConfig);
  }

  onConfirm(): void {
    if (this.filterForm.valid && !this.dateRangeError) {
      const formValue = this.filterForm.value;

      const statusesWithState = this.data.statuses.map((status: string, index: number) => ({
        checked: formValue.runStatuses[index],
        id: status.toLowerCase().replace(/\s+/g, ''),
        name: status,
      }));

      const result: SimulationSearchFilters = {
        runStatus: statusesWithState,
        startDate: formValue.startDate,
        endDate: formValue.endDate,
        directions: {
          x: formValue.directionX,
          y: formValue.directionY,
          z: formValue.directionZ,
        },
      };

      if (!this.hideTypes && this.data.simTypes && formValue.types) {
        result.types = this.data.simTypes.map((type: string, index: number) => ({
          checked: formValue.types[index],
          id: type.toLowerCase().replace(/\s+/g, ''),
          name: type,
        }));
      } else if (!this.hideTypes) {
        result.types = [];
      }

      this.dialogRef.close(result);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
